import { ActionReducerMap, Store as BaseStore } from '@ngrx/store';

import users, {
  defaultState as usersDefaultState,
  State as UsersState,
} from './users/main';
import { Effects as UsersEffects } from './users/effects';
import { Action as UsersAction } from './users/actions';

import auth, {
  defaultState as authDefaultState,
  State as AuthState,
} from './auth/main';
import { Effects as AuthEffects } from './auth/effects';
import { Action as AuthAction } from './auth/actions';

import runManagement, {
  defaultState as runManagementDefaultState,
  State as RunManagementState,
} from './run-management/main';
import { RunManagementEffects } from './run-management/effects';
import { Action as RunManagementAction } from './run-management/actions';

import { InjectionToken } from '@angular/core';

// Root store state type
export interface State {
  users: UsersState;
  auth: AuthState;
  runManagement: RunManagementState;
}

// Root store action type
export type Action = UsersAction | AuthAction | RunManagementAction;

// The app store type
export type Store = BaseStore<State>;

export const ROOT_REDUCER = new InjectionToken<ActionReducerMap<State, Action>>(
  'RootReducer',
  {
    factory: () => ({
      users,
      auth,
      runManagement,
    }),
  },
);

// Root reducer
export const reducers: ActionReducerMap<State, Action> = {
  users,
  auth,
  runManagement,
};

export function getInitialState(): State {
  return {
    users: usersDefaultState,
    auth: authDefaultState,
    runManagement: runManagementDefaultState,
  };
}

export const Effects = [AuthEffects, UsersEffects, RunManagementEffects];

// Common shared actions
export interface ErrorAction {
  error: Error;
}
